import '/app/brewery-packages/content/content-editor-plugin-link/src/Link.css-raw';
export default {
  "link": "contacts-cbf4f629-link-d8xOKa"
};